<template>
  <span class="help-text font-paragraph-p2-small color-gray-3-60">
    <template v-if="text">
      {{ text }}
    </template>

    <slot v-else />
  </span>
</template>

<script lang="ts">
export default {
  name: 'KomodoHelpText'
}
</script>

<script setup lang="ts">
defineProps<{
  text?: string
}>()
</script>
